export const AuthRequest = "AuthRequest";
export const AuthSuccess = "AuthSuccess";
export const AuthError = "AuthError";
export const AuthLogout = "AuthLogout";
